// @flow
// This file is generated by make-version-metadata.js script
// Don't import this file directly, prefer to use newIDE/app/src/Version/index.js instead.
// prettier-ignore
module.exports = {
  "version": "5.6.276",
  "gitHash": "8ceaebb3a308fe903ab12e14e737ec780ebf82cf",
  "versionWithHash": "5.6.276-8ceaebb3a308fe903ab12e14e737ec780ebf82cf"
};
